import { createFileRoute } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { AttestationsPage } from '../../../../../components/pages/backoffice/common/attestations-page/attestations-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/contracts/$subscriptionId/attestations')({
  component: function Component() {
    const { subscriptionId } = Route.useParams()

    return (
      <PermissionChecker requiredPermissions={[anyOfPermissions('contract.read', 'contract.read.relatedOnly')]}>
        <AttestationsPage subscriptionId={subscriptionId} />
      </PermissionChecker>
    )
  },
})
